/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-eval */
import Axios from 'axios';
import _ from 'lodash';
import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation, useParams } from 'react-router-dom';
import {
  UrlBase,
  URL_PLUGIN,
  URL_PLUGIN_FRONTEND,
  URL_PLUGIN_PROD,
  URL_PLUGIN_SEGUROS,
} from 'src/parametros';
import { setCotizacion, setCotizacionConfig } from 'src/reducers/Cotizacion/cotizacion.actions';
import useInputsResources from 'src/reducers/InputsResources/useInputsResources';
import { guardarLead, guardarLeadPoliza } from 'src/services';
import * as urls from 'src/services/urls';
import { fromB64, roundTo, toB64 } from 'src/utils/functiones';
import styled from 'styled-components';
import useCotizacion from './useCotizacion';
import useCustomRouter from './useCustomRouter';
import useCustomToast from './useCustomToast';
import useQueryString from './useQueryString';
import publicIp from 'public-ip';
import moment from 'moment';
// import { registerPreset, transform } from '@babel/standalone';
// import Preset from '@babel/preset-react';
// "@babel/preset-react": "^7.12.13",
// "@babel/standalone": "^7.12.18",
// registerPreset('@babel/preset-react', {
//   presets: [Preset],
// });

const callbacks = {
  global: [],
  paginaPreview: ['initCallback', 'outCallback', 'onClickAdquirirCallback'],
  paginaCompra: [
    'initCallback',
    'onClickContinuarCallback',
    'onClickGuardarCallback',
    'outCallback',
    'dispatchCotizacionSetBeneficiarios',
    'initBeneficiarioIgualTitularCallback',
  ],
  paginaResumen: [
    'initCallback',
    'onClickContinuarCallback',
    'onClickGuardarCallback',
    'outCallback',
    'dispatchCotizacionSetBeneficiarios',
    'initBeneficiarioIgualTitularCallback',
  ],
  paginaPago: [
    'initCallback',
    'onClickContinuarCallback',
    'onClickGuardarCallback',
    'outCallback',
    'dispatchCotizacionSetBeneficiarios',
    'initBeneficiarioIgualTitularCallback',
  ],
  paginaTitular: ['initCallback', 'outCallback', 'onClickContinuarCallback'],
  extraDataForm: ['initCallback', 'outCallback', 'onClickContinuarCallback'],
  finCompra: ['initCallback'],
  ingresarPoliza: [
    'initCallback',
    'afterVerificarPoliza',
    'polizaIngresada',
    'ingresarPoliza',
    'redireccionarAfterSave',
    'outCallback',
  ],
  firmarPolizaEvicertia: ['onClickFirmar', 'initCallback'],
  firmarCertificadoEvicertia: ['onClickFirmar', 'initCallback'],
  firmarCertificado: ['onClickFirmar', 'initCallback'],
  cambiosuscripcionptp: [],
};

const usePageValidation = (pagina) => {
  const toasts = useCustomToast();
  const [events, setEvents] = useState<Object>({});
  const history = useCustomRouter();

  const [isLoading, setisLoading] = useState(true);

  const qParams = useQueryString();
  const routeParams = useParams();
  const location = useLocation();
  const dispatch = useDispatch();
  const { cotizacion }: any = useCotizacion();
  const inputsResources = useInputsResources();

  const decoratorFunction =
    async (callback: CallableFunction) =>
      async (params: any = {}) => {
        const { default: defaultImport } = await import('src/store');

        const redux = defaultImport;

        return callback({
          _,
          location,
          qParams,
          routeParams,
          Axios,
          React,
          toasts,
          history,
          cotizacion,
          redux,
          styled,
          idCotizacion: cotizacion?.idCotizacion,
          fromB64,
          toB64,
          guardarLead,
          roundTo,
          setCotizacion,
          dispatch,
          guardarLeadPoliza,
          inputsResources,
          setCotizacionConfig,
          publicIp,
          moment,
          urls: {
            URL_PLUGIN,
            URL_PLUGIN_PROD,
            URL_PLUGIN_FRONTEND,
            URL_PLUGIN_SEGUROS,
            UrlBase,
            ...urls,
          },
          ...params,
        });
      };

  const getFunction = async (validaciones = [], pagina: string, fn: string) => {
    const value = _.get(validaciones, `${pagina}.${fn}`, 'NO_EXISTE');
    if (value && value !== null && value !== '' && value !== 'NO_EXISTE') {
      // const { code } = transform(value, {
      //   presets: ['@babel/preset-react'],
      // });

      const functionBD = eval(value);
      return await decoratorFunction(functionBD);
    }
    return null;
  };

  const init = useCallback(async () => {
    if (cotizacion?.configuracion && pagina) {
      const { validaciones } = cotizacion.configuracion;

      console.log('validaciones', pagina, callbacks[pagina]);

      if (callbacks[pagina].length > 0) {
        const newEvents = await Promise.all(
          // callbacks.paginaCompra.map(async (validacion) => [
          callbacks[pagina]?.map(async (validacion) => [
            validacion,
            await getFunction(validaciones, pagina, validacion),
          ]),
        );
        console.log('newEvents', newEvents);
        setEvents(Object.fromEntries(newEvents));
      }
    }
    setisLoading(false);
  }, []);

  const execEvent = async (fn: string, params: any = null, callback: CallableFunction = null) => {
    //if (!isLoading) return;
    console.log('PAGE-VALIDATION-1', cotizacion?.configuracion, events);

    try {
      if (cotizacion?.configuracion && events[fn]) {
        const res = await events[fn](params);
        console.log('PAGE-VALIDATION', fn);
        if (res && res?.continue) {
          if (callback) await callback(res);
        } else if (!res) {
          if (callback) await callback(res);
        }
      } else {
        if (callback) await callback();
      }
    } catch (error) {
      console.log('ERROR execevent', error);
      if (error instanceof PageValidationError) {
        console.log(error);
        error.throwMessage && toasts.addWarningToast(error.throwMessage);
      } else {
        console.error(error);
      }
    }
  };

  useEffect(() => {
    init();
  }, [init]);

  return { events, execEvent, isLoadingCallbacks: isLoading };
};

export default usePageValidation;

export class PageValidationError extends Error {
  throwMessage: string = null;
  constructor(message, throwMessage = null) {
    super(message);
    this.message = message;
    this.name = 'PageValidationError';
    this.throwMessage = throwMessage;
  }
}
